module.exports = __webpack_public_path__ + "static/media/call15.05d8c12d.gif";